import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  fieldMappingAll: [],
  fieldMapping: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const fieldMappingSlice = createSlice({
  name: "fieldMapping",
  initialState,
  reducers: {
    setFieldMappingAll: (state, action) => {
      state.fieldMappingAll = action.payload;
    },
    setFieldMapping: (state, action) => {
      state.fieldMapping = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setFieldMappingAll,
  setFieldMapping,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = fieldMappingSlice.actions;

export default fieldMappingSlice.reducer;
